import clsx from 'clsx'
import React from 'react'

import type { BrandingMedia } from '@/Branding/resolveAsset'
import { resolveBrandingAsset } from '@/Branding/resolveAsset'

interface Props {
  className?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
  resource?: BrandingMedia
}

export const Logo = (props: Props) => {
  const { loading: loadingFromProps, priority: priorityFromProps, className, resource } = props

  const loading = loadingFromProps || 'lazy'
  const priority = priorityFromProps || 'low'
  const logo = resolveBrandingAsset({
    fallbackAlt: 'Tarcontent Cloud',
    fallbackMimeType: 'image/svg+xml',
    fallbackSrc: '/tarcontent-cloud-logo.svg',
    resource,
  })

  return (
    /* eslint-disable @next/next/no-img-element */
    <img
      alt={logo.alt}
      width={logo.width || 250}
      height={logo.height || 40}
      loading={loading}
      fetchPriority={priority}
      decoding="async"
      className={clsx('h-10 w-auto max-w-[15.625rem]', className)}
      src={logo.src}
    />
  )
}
